import clsx from 'clsx';
import Image from 'next/image';
import { FaUserCircle } from 'react-icons/fa';

import { isPresent } from 'shared/lib/utils';

function UserPictureAndUsername({
  user,
  sizes,
  fill,
  width,
  height,
  className,
}: {
  user;
  sizes?: string;
  width?: number;
  height?: number;
  className?: string;
  fill?: boolean;
}) {
  return (
    <div className={clsx(['flex items-center gap-1', className])}>
      <figure>
        {(() => {
          if (isPresent(user.get('picture'))) {
            return (
              <Image
                width={width}
                height={height}
                fill={fill}
                sizes={sizes}
                className="rounded-full"
                src={user.get('picture')}
                alt={`${user.get('username')}'s profile picture`}
              />
            );
          }
          return <FaUserCircle fill="#85C1E9" />;
        })()}
      </figure>

      <p className="text-green-600">{user.get('username', 'Guest')}</p>
    </div>
  );
}

export default UserPictureAndUsername;
